// extracted by mini-css-extract-plugin
module.exports = {"root":"_2a-tH","intro":"_3CV3K","portraits":"_2WXtS","portrait":"_1daE2"};